<p-menu #statusFilterOverlay [popup]="true" [model]="statusFilterOption"></p-menu>
<form [formGroup]="soaFilterForm">
    <div class="p-mx-2">

        <div class="p-grid p-mt-0 p-jc-between p-ai-center">

            <!--Search By Invoice Number-->
            <div class="p-col-12 p-md-6 p-xl-4">
                    <span class="p-input-icon-right p-float-label width-100">
                        <input (change)="onSearchOfStatement()" formControlName="filterByIdentifier" type="text"
                               class="width-100" pInputText/>
                        <label>Invoice / Transport Document</label>
						<i class="pi pi-search"></i>
					</span>
            </div>

            <div class="p-col-12 p-md-6 p-xl-6">
                <div class="p-grid p-mt-0 p-ai-center p-jc-end">
                    <div *ngIf="isAdmin" class="p-col-10 p-xl-8">
                          <span class="p-field">
                            <p-dropdown (onChange)="applyCustomerSOAFilter()" [filter]="true"
                                        [options]="soaCustomers"
                                        [showClear]="soaFilterForm?.value?.businessEntityId?.length > 0"
                                        appendTo="body"
                                        emptyFilterMessage="Filtered Value not found"
                                        emptyMessage="No Customers Found"
                                        filterBy="name"
                                        formControlName="businessEntityId"
                                        optionValue="businessEntityId"
                                        optionLabel="name"
                                        placeholder="Select Customer">
                                <ng-template let-soaCustomer pTemplate="items">
                                    {{soaCustomer?.name}}
                                </ng-template>
                            </p-dropdown>
                          </span>
                    </div>
                    <div class="p-col-2 p-xl-1 p-mt-1 p-text-right">
                        <img (click)="statusFilterOverlay.toggle($event)" alt=""
                             class="p-cursor" pRipple src="assets/branding/shared-icons/filter-secondary.svg"
                             style="height: calc(2rem + 1vmin);">
                    </div>
                </div>

            </div>
        </div>

    </div>
</form>
